(function () {
  'use strict';

  var KEY = 'wishlist';

  function getList() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveList(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
  }

  function updateButtons() {
    var list = getList();
    var buttons = document.querySelectorAll('.wishlist-btn');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var active = list.indexOf(btn.dataset.handle) !== -1;
      btn.setAttribute('aria-pressed', active);
      btn.classList.toggle('is-active', active);
      btn.textContent = active ? '♥ In wishlist' : '♡ Add to wishlist';
    }

    var countEl = document.querySelector('.wishlist-count');
    if (countEl) {
      countEl.textContent = list.length;
      countEl.hidden = list.length === 0;
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.wishlist-btn');
    if (!btn) return;
    var handle = btn.dataset.handle;
    var list = getList();
    var index = list.indexOf(handle);
    if (index === -1) {
      list.push(handle);
    } else {
      list.splice(index, 1);
    }
    saveList(list);
    updateButtons();
    if (document.getElementById('wishlist-items')) renderWishlist();
  });

    function formatMoney(cents) {
    return (cents / 100).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function esc(s) {
    return String(s).replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }

    function renderWishlist() {
    var container = document.getElementById('wishlist-items');
    if (!container) return;

    var list = getList();
    if (!list.length) {
      container.innerHTML = '<p>Your wishlist is empty.</p>';
      return;
    }

    Promise.all(
      list.map(function (handle) {
        return fetch('/products/' + handle + '.js').then(function (r) {
          return r.ok ? r.json() : null;
        });
      })
    ).then(function (products) {
      var html = '';
      products.forEach(function (p) {
        if (!p) return;

        var variant = null;
        var onSale = false;
        for (var i = 0; i < p.variants.length; i++) {
          var v = p.variants[i];
          if (!variant && v.available) variant = v;
          if (v.compare_at_price && v.compare_at_price > v.price) onSale = true;
        }

        var multi = p.variants.length > 1;

        // Badge: single variant hole "X% OFF", various hole "Sale"
        var badge = '';
        var priceHtml = formatMoney(p.price);
        if (onSale) {
          if (multi) {
            badge = '<span class="wl-badge">Sale</span>';
          } else {
            var v0 = p.variants[0];
            var pct = Math.round((v0.compare_at_price - v0.price) / v0.compare_at_price * 100);
            badge = '<span class="wl-badge">' + pct + '% OFF</span>';
            priceHtml += '<s>' + formatMoney(v0.compare_at_price) + '</s>';
          }
        }

        var img = p.featured_image ? p.featured_image + '&width=300' : '';
        var actions;

        if (variant) {
          actions =
            '<button type="button" class="wl-btn wl-add" data-variant="' + variant.id + '">Add to cart</button>' +
            '<a class="wl-btn wl-buy" href="/cart/' + variant.id + ':1">Buy now</a>';
          if (multi) {
            actions += '<a class="wl-btn wl-choose" href="' + p.url + '">Choose options</a>';
          }
        } else {
          actions = '<button type="button" class="wl-btn" disabled>Sold out</button>';
        }

        html +=
          '<div class="wishlist-item">' + badge +
          '<a href="' + p.url + '">' +
          (img ? '<img src="' + img + '" alt="' + esc(p.title) + '" width="300" height="300" loading="lazy">' : '') +
          '<h3>' + esc(p.title) + '</h3></a>' +
          '<p class="wl-price">' + priceHtml + '</p>' +
          '<div class="wl-actions">' + actions +
          '<button class="wishlist-btn" data-handle="' + p.handle + '" type="button"></button>' +
          '</div></div>';
      });
      container.innerHTML = html;
      updateButtons();
    });
  }

  function init() {
    updateButtons();
    renderWishlist();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();